import { render, staticRenderFns } from "./edit-policy.vue?vue&type=template&id=1ad307ed&scoped=true&"
import script from "./edit-policy.vue?vue&type=script&lang=js&"
export * from "./edit-policy.vue?vue&type=script&lang=js&"
import style0 from "./edit-policy.vue?vue&type=style&index=0&id=1ad307ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad307ed",
  null
  
)

export default component.exports